import React, {useEffect, useState} from 'react'
import {TableWithStripedRows} from "../../../components/elements/Tables/TableComponent";
import {SALES_STATUS, setMoney} from "../../../utils/shared";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import * as moment from "moment";

function ContainerReport(props) {
  const {listSalesReport, data, loader} = props;
  const [didMount, setMount] = useState(false);
  const [params, setParams] = useState({});
  useEffect(() => {
    setMount(true)
  }, []);

  useEffect(() => {
    if (didMount) {
      listSalesReport(params)
    }
  }, [didMount]);


  useEffect(() => {
    if (didMount && Object.keys(params).length) {
      listSalesReport(params)
    }
  }, [params]);

  const columnsName = [
    {selector: row => row.id, name: 'ID'},
    {selector: row => row.branch_office_user_name, name: 'Sucursal'},
    {selector: row => row.cashier_person_name, name: 'Cajero/usuario'},
    {selector: row => moment(row.creation_date).format("DD/MM/YYYY HH:mm"), name: 'Fecha y Hora'},
    {selector: row => row.status, name: 'Estado'},
    {selector: row => row.nit, name: 'NIT'},
    {selector: row => setMoney(parseFloat(row.total)), name: 'Total'},
  ]

  const Filters = [
    {
      placeholder: 'Fecha Inicio',
      name_filter: 'date_start',
      initialDate: new Date(),
      maxdate: undefined
    },
    {
      placeholder: 'Fecha Fin',
      name_filter: 'date_end',
      initialDate: new Date(),
      mindate: undefined
    },
    {
      placeholder: 'Sucursal',
      name_filter: 'branch_office_id',
      urlOptionList: 'branch-offices/select'
    },
    {
      placeholder: 'Usuario',
      name_filter: 'user_id',
      urlOptionList: 'user/select_option'
    },
    {
      placeholder: 'Estado',
      name_filter: 'estado',
      urlOptionList: '',
      options: SALES_STATUS
    },
  ]

  const changeFilterById = (filterValue) => {
    let newFilter = filterValue;
    if (params && typeof (params) === 'object' && Object.keys(params).length) {
      // Si ya existe un filtro que lo mantenga, y que sobrescriba su valor
      setParams({...params, ...newFilter})
    } else {
      // de lo contrario que agregue ese filtro
      setParams(newFilter);
    }
  }



  return (
    <ContainerComponent
      title={'Reporte de Ventas'}
      
    >
      <TableWithStripedRows
        filters={Filters}
        loader={loader}
        data={data}
        sumarColumna={'total'}
        titleExcel="Reporte de Ventas"
        paginationServer={false}
        changeFilter={changeFilterById}
        showSearch={false}
        dontShowAction={true}
        columns={columnsName}
      />

    </ContainerComponent>
  )
}

export default ContainerReport;